import Controller from '@ember/controller';
import { alias } from '@ember/object/computed';
import { tracked } from '@glimmer/tracking';

import DS from 'ember-data';
import DomainModel from 'cio/models/domain';
import IdentityModel from 'cio/models/identity';
import MailServerModel from 'cio/models/mail-server';

const DEFAULTS = {
  domain: '',
};

export default class SendingDomainsController extends Controller {
  queryParams = ['domain'];

  @tracked domain = DEFAULTS.domain;

  @alias('model.domains') domains!: DS.RecordArray<DomainModel>;
  @alias('model.identities') identities!: DS.RecordArray<IdentityModel>;
  @alias('model.identitiesInUse') identitiesInUse!: DS.RecordArray<IdentityModel>;
  @alias('model.mailServers') mailServers!: DS.RecordArray<MailServerModel>;

  setDefaults() {
    this.domain = DEFAULTS.domain;
  }
}
